import { render, staticRenderFns } from "./AddPostOptional.vue?vue&type=template&id=ab43d53e&scoped=true&lang=pug&"
import script from "./AddPostOptional.vue?vue&type=script&lang=js&"
export * from "./AddPostOptional.vue?vue&type=script&lang=js&"
import style0 from "./AddPostOptional.vue?vue&type=style&index=0&id=ab43d53e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43d53e",
  null
  
)

export default component.exports